import { Box } from 'grommet';
import React from 'react';
import { withTranslation } from 'react-i18next';
const HeaderAppBar = withTranslation()((props) => {
    const { children } = props;
    return (React.createElement(Box, { tag: "header", direction: "row", align: "center", justify: "between", background: "brand", pad: { left: 'medium', right: 'small', vertical: 'small' } }, children));
});
HeaderAppBar.displayName = 'HeaderAppBar';
export default HeaderAppBar;
